import useSectionScopeChange from '../../../../../../permissions/scopes/section/hooks/useSectionScopeChange';
import Tabs from '../../../../../../../ui/tabs/Tabs';
import Loader from '../../../../../../../ui/loader/Loader';
import NotFoundAlert from '../../../../elements/not-found-alert/NotFoundAlert';
import useSectionPermissions from '../../../../../../permissions/scopes/section/hooks/useSectionPermissions';
import { useCallback, useEffect, useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { AdminRoutes } from '../../../../helpers/routing';
import { useRouting } from '../../../../hooks/useRouting';
import { useGetAssistant, useGetAssistantEvaluationCollection } from '../../hooks/useAssistantsService';
import { useAdminLabels } from '../../../../../../../hooks/useLabels';

const EvaluateLayout = () => {
    const labels = useAdminLabels();

    const { paths, routeTo, getRouteParams } = useRouting();
    const params = getRouteParams('evaluationCollection');
    const { isLoading: isLoadingAssistant } = useGetAssistant(params);
    const { data: evaluationData, isLoading: isLoadingEvaluation } = useGetAssistantEvaluationCollection(params);

    const { canView } = useSectionPermissions();
    const evaluationKey = getRouteParams('evaluationCollection').evaluationKey;
    const isAllowed = (!!(evaluationData?.key === evaluationKey) && canView());

    // TODO: Create evaluations loader of some sort here and use instead of getAssistantVersion
    // const { isLoading: isLoadingVersion } = useGetAssistantVersion(params);

    useSectionScopeChange({ scope: params.assistantId });


    // TODO: Make this a generic helper
    // - tabs
    // - activeTabId
    // - handleTabChange
    // - invalid tab handling
    const tabs = useMemo(() => Object.values([AdminRoutes.manual, AdminRoutes.session]).map(label => {
        return ({
            id: label.toString(),
            tab: labels?.[`${label}Tab` as keyof typeof labels] as string || label,
            // filterOut: !data?.data.type ? true : data?.data.type === 'workflow' && label === AdminRoutes.prompt,
            content: ''
        });
    }), [labels]);

    const activeTabId = useMemo(() => [...paths].reverse().find(path => tabs.some(tab => tab.id === path)), [paths, tabs]);

    const handleTabChange = useCallback((tabId: string) => {
        const target = tabId as 'publish' | 'prompt' | 'changelog' | 'knowledge';
        routeTo(target, {}, true);
    }, [routeTo]);

    useEffect(() => {
        const isInvalidTabId = !tabs.find(x => x.id === activeTabId);
        if (isInvalidTabId) {
            const firstTabId = tabs[0]?.id;
            if (firstTabId)
                handleTabChange(firstTabId);
        }
    }, [tabs, activeTabId, handleTabChange]);

    return (
        <>
            <Tabs activeTabId={activeTabId} tabs={tabs} onActiveTabChange={handleTabChange} />
            {(isLoadingAssistant || isLoadingEvaluation) ? <Loader isRelative /> : isAllowed ? <Outlet /> : <NotFoundAlert padTop message={labels.assistantsEvaluationNoAccess} />}
        </>
    );
};

export default EvaluateLayout;